export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true
};
export const PageName = '转账列表';